/* eslint-disable */
export default {
  cancel: 'Cancelar',
  pmiChangeConfirmed: 'Cambiar',
  pmiChangeConfirmTitle: '¿Desea cambiar los ajustes de la reunión personal?',
  pmiChangeConfirmContext:
    'Cambiar esta configuración afectará a todas las reuniones que utilicen su nombre o ID de reunión personal, incluidas las que ya haya programado.',
  updatePassword: 'Actualizar contraseña',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"pmiChangeConfirmed"@#@ @source: @#@"Change"@#@
// @key: @#@"pmiChangeConfirmTitle"@#@ @source: @#@"Change Personal Meeting settings?"@#@
// @key: @#@"pmiChangeConfirmContext"@#@ @source: @#@"Changing these settings will affect all meetings that use your personal meeting ID or name, including those you've already scheduled"@#@
// @key: @#@"updatePassword"@#@ @source: @#@"Update password"@#@
